import { render, staticRenderFns } from "./displayCategoryMessage.vue?vue&type=template&id=47bd59be&scoped=true&"
import script from "./displayCategoryMessage.vue?vue&type=script&lang=js&"
export * from "./displayCategoryMessage.vue?vue&type=script&lang=js&"
import style0 from "./displayCategoryMessage.vue?vue&type=style&index=0&id=47bd59be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bd59be",
  null
  
)

export default component.exports